// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LeadHead__Wrapper_PBPhk","Title":"LeadHead__Title_23S-x","Subtitle":"LeadHead__Subtitle_7RlUJ","Link":"LeadHead__Link_1gOcA"};